/**
 * Minimal JWT claim reader — NÃO valida assinatura.
 *
 * Usado apenas para ler claims não-sensíveis do token já armazenado localmente
 * (ex: `masterLogin` para sessões de suporte). A validação real é feita pelo
 * backend a cada request.
 */

export interface JwtClaims {
  id?: string;
  email?: string;
  firstName?: string;
  companyId?: string;
  levelId?: string;
  masterLogin?: boolean;
  iat?: number;
  exp?: number;
}

export function decodeJwtClaims(token: string): JwtClaims | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3 || !parts[1]) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '==='.slice((payload.length + 3) % 4);
    const json = atob(padded);
    return JSON.parse(json) as JwtClaims;
  } catch {
    return null;
  }
}
